export default "__VITE_ASSET__veyB7MpU__"